import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { AlertTriangle } from 'lucide-react';

const ConfirmDeleteDialog = ({ 
  open, 
  onOpenChange, 
  onConfirm, 
  title = "Are you sure?",
  description = "This action cannot be undone.",
  itemName = "",
  confirmText = "Delete"
}) => {
  const handleConfirm = async () => {
    // Close dialog first for better UX
    onOpenChange(false);
    // Then execute the confirm action
    if (onConfirm) {
      await onConfirm();
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-red-600" />
            </div>
            <AlertDialogTitle className="text-xl">{title}</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-base pt-4">
            {description}
            {itemName && (
              <div className="mt-3 p-3 bg-gray-50 dark:bg-secondary rounded-lg border border-gray-200 dark:border-border">
                <span className="font-semibold text-gray-900 dark:text-foreground">{itemName}</span>
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmDeleteDialog;
